export default "__VITE_ASSET__b7bda769__"